import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Services = lazy(() => import('../pages/services/page'));
const ArtPaintings = lazy(() => import('../pages/art-paintings/page'));
const GraphicDesign = lazy(() => import('../pages/graphic-design/page'));
const Storytelling = lazy(() => import('../pages/storytelling/page'));
const Education = lazy(() => import('../pages/education/page'));
const Portfolio = lazy(() => import('../pages/portfolio/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/art-paintings',
    element: <ArtPaintings />,
  },
  {
    path: '/graphic-design',
    element: <GraphicDesign />,
  },
  {
    path: '/storytelling',
    element: <Storytelling />,
  },
  {
    path: '/education',
    element: <Education />,
  },
  {
    path: '/portfolio',
    element: <Portfolio />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;